var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.pendingRequests > 0)?_c('md-progress-bar',{attrs:{"md-mode":"indeterminate"}}):_vm._e(),_c('notifications'),_c('qrcode-scanner'),_c('global-key-enter'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }